import u from '@/utility/utility';

export class BillOfLadingModel {
    public createdBy!: string;
    public createdDate!: string;
    public id!: number;
    public modifiedBy!: any;
    public modifiedDate!: any;
    public orderCodeId!: number;
    public orderId!: number;
    public orderTransactionCode!: string;
    public productName!: string;
    public packageType!: any;
    public status!: number;
    public statusDetail!: any;
    public uId!: number;
    public userName!: string;
    public weight!: string;
    public volume!: string;
    public isChecked!: boolean;
}

export class Lading {
    public id: any = u.randomString(20);
    public binCode!: string;
    public productName!: string;
    public isValid = true;
};